// 在线文档
import React, {memo} from 'react'
import styled from 'styled-components'
import Schedule from "@/icons/common/schedule.png";

const DocMsg = styled.div`
  width: 240px;
  height: 111px;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  color: #595959;
  .docDetail {
    height: 78px;
    padding: 8px;
    border-bottom: 1px solid #E9E9E9;
  }
  .docTitle {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .docContent {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .docType {
    display: flex;
    align-items: center;
    height: 32px;
    font-size: 12px;
    padding-left: 8px;
    font-weight: 400;
    img {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
`

const RenderDocMsg = memo((props) => {
  const {value} = props
  let message = value.messageContent ? JSON.parse(value.messageContent) : {}
  const str = message.description?message.description.split("组织者"):["",""]
  return(
    <DocMsg onClick={()=>window.open(message.linkUrl)}>
      <div className="docDetail">
        <div className="docTitle">{message.title}</div>
        <div className="docContent">{str[0]}</div>
        <div className="docContent">{`组织者${str[1]}`}</div>
      </div>
      <div className="docType"><img src={Schedule} />日程</div>
    </DocMsg>
  )
})

export default RenderDocMsg
